module.exports = __webpack_public_path__ + "img/scene-industry.660015fe.jpg";